export default {
	pageTitle: 'Dokumenty',
	documentType: 'Typ dokumentu',
	scan: 'Sken',
	reportDateFrom: 'Datum vykázání od',
	reportDateTo: 'Datum vykázání do',
	withoutPpz: 'Včetně záznamů podřízených',
	policyNo: 'Číslo PS',
	name: 'Popis',
	client: 'Klient',
	reportDate: 'Datum vykázání',
	sellerIn: 'Získatelské číslo',
	sellerInShort: 'ZČ',
	lockedTooltip: 'Výkaz je uzamčen',
	checkSquareTooltip: 'Výkaz je v pořádku vyplněný a čeká na uzamčení',
	document: 'Dokument',
	lightBoxTitle: 'Přejete si označené záznamy smazat?',
	lightBoxCloseReportWithoutPpz: 'Budou uzavřeny pouze vaše vykázané dokumenty',
	clear: 'Smazat',
	closeReport: 'Uzavřít výkaz',
	newDocumentReport: 'Výkaz nového dokumentu',
	documentRecordsLimit:
		'Počet dokumentů je větší než 200. Omezte datum vykázání od a datum vykázání do. Datum vykázání od smí být maximálně měsíc zpět',
};
